import { useMemo } from "react";
import useDebounce from "./useDebounce";

function useSearch(
	data: any,
	searchValue: string | Record<string, string[]>,
	...filters: ((data: any[], query: string) => any[])[]
) {
	const debouncedQuery = useDebounce(searchValue, 500);

	return useMemo(() => {
		const dataArray = Array.isArray(data) ? data : [data];

		try {
			// Apply each filter function in sequence
			return filters.reduce(
				(acc, feature) => feature(acc, debouncedQuery),
				dataArray
			);
		} catch (error) {
			console.error("Error applying search features:", error);
			return dataArray;
		}
	}, [data, debouncedQuery, searchValue]);
}

export default useSearch;
